import gql from 'graphql-tag';

export const ConsumerAccountAddressFields = gql`
  fragment ConsumerAccountAddressFields on AccountAddress {
    id
    name
    address_line_1
    address_line_2
    city
    state
    post_code
    country {
      id
      name
    }
    soft_deleted
  }
`;

export const UserDetails = gql`
  fragment UserDetails on Account {
    id
    email_address
    username
    name
    phone_number
    organization_name
    slug
    addresses {
      ...ConsumerAccountAddressFields
    }
  }
  ${ConsumerAccountAddressFields}
`;
